import React, { useEffect, useRef, useState } from "react";

export const Select2 = ({
    opciones = [{text: '-- Seleccione --',value: 0}],
    value = 0,
    functionChangeValue,
    disabled = false,
    tabIndexInput
}) => {
    const classNameInput = "containerScroll text-white h-[30px] rounded px-4 w-full bg-zinc-800 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500 caret-white"   
    const refInput = useRef()
    const refSelect2 = useRef()

    const [muestraOpciones,setMuestraOpciones] = useState(false)
    const [textoInput,setTextoInput] = useState('')

    const eventoTest = (e) => {
        if(!refSelect2.current.contains(e.target)){
            setMuestraOpciones(false)
        }
    }
    
    useEffect(() => {   //EVENTO PARA OCULTAR EL COMPONENTE AL CLICKEAR FUERA DE EL
        document.addEventListener('click', eventoTest)
        return(() => {
            document.removeEventListener('click',eventoTest)
        })
    },[])

    useEffect(() => {
        if(muestraOpciones) {
            setTextoInput('')
            refInput.current.focus()
        }
    },[muestraOpciones])
    
    return (
        <div ref={refSelect2} className="relative w-full">
            <div onClick={e => disabled ? '' : setMuestraOpciones(!muestraOpciones)} className={`${muestraOpciones ? 'ring-[#366bc3] ring-1' : ''} text-xs h-[30px] w-full bg-[#27272a] rounded ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'} flex items-center justify-between px-3`}>
                <span>{opciones.find(e => e.value == value)?.text || ''}</span>
                <i className={`fa ${muestraOpciones ? 'fa-angle-up' : 'fa-angle-down'}`} aria-hidden="true"></i>
            </div>
            <div className={`${muestraOpciones ? '' : 'hidden'} absolute z-50 top-full border-2 border-[#4d4d4d] w-full`}>
                <div className="flex items-center justify-center p-2 bg-[#27272a] border-b-2 border-[#4d4d4d]">
                    <input 
                        tabIndex={tabIndexInput} 
                        ref={refInput} 
                        value={textoInput} 
                        onChange={e => setTextoInput(e.target.value)} 
                        placeholder="(Texto)" 
                        className={`${classNameInput} border border-[#4d4d4d]`} 
                    />
                </div>
                <ul className="max-h-[200px] overflow-auto containerScroll">
                    {
                        opciones.filter(elem => elem.text.toLowerCase().includes(textoInput.toLowerCase())).map((data,i) => {
                            return (
                                <li 
                                    key={i+1} 
                                    onClick={() => {
                                        functionChangeValue(data.value)
                                        setMuestraOpciones(false)
                                    }} 
                                    className={`${value == data.value ? 'bg-[#1967d2]' : 'hover:bg-[#1967d2]'} cursor-pointer px-3 text-xs py-2 bg-[#27272a]`}
                                >
                                    {data.text}
                                </li>
                            )
                        })
                    }
                </ul>
            </div>
        </div>
    )
};
